export const editPhoneNumber = (input: string) => {
  // Оставляем только цифры
  let d = input.replace(/\D/g, "");

  // Если номер не начинается с 7 — добавим
  if (d[0] !== "7") d = "7" + d;

  // Ограничим максимум 11 цифрами
  d = d.slice(0, 11);

  let result = "+7";

  if (d.length > 1) result += " (" + d.slice(1, 4);
  if (d.length >= 4) result += ")";
  if (d.length > 4) result += " " + d.slice(4, 7);
  if (d.length > 7) result += "-" + d.slice(7, 9);
  if (d.length > 9) result += "-" + d.slice(9, 11);

  return result;
}
